export default __webpack_public_path__ + "static/media/ic-overall.c1d97a06.svg";